$(document).ready(function () {
	$(document).on('click', '[data-toggle="click-price"]', function () {
		$(this).closest('.variant-area--single').find('.current').removeClass('current');
		$(this).addClass('current');

		let $item = $(this).closest('[data-product-item], [data-product]');
		let $price = $item.find('.price');
		$price.attr('data-price', $(this).data('price'));
		let price = ProductItem.calcPrice($item);
		$price.find('span').attr('data-price', price).html(output_money(price));

		return false;
	});

	$(document).on('change', '[data-toggle="change-price"]', function () {
		let price = $(this).find('option:selected').data('price'),
			$container = $(this).closest('.variant-area--select');

		let $price = $container.find('.price');

		$price.attr('data-price', price);

		let newPrice = ProductItem.calcPrice(
			$(this).closest('[data-product-item], [data-product]')
		);

		$price.find('span').data('price', newPrice).text(output_money(newPrice));

		return false;
	});
});